export class LinkToModel {
  pathname: String;
  hash: String;
  search: Object;

  constructor(pathname, hash, search) {
    this.pathname = pathname
    this.hash = hash
    this.search = search
  }

  toString(): String {
    let path: String = this.pathname;

    if(this.hash) {
      path += this.hash
    } else if(this.search) {
      path += this.search
    }

    return path
  }
}
